import { ButtonGroup as MuiButtonGroup } from '@mui/material'
import { merge, size } from 'lodash'
import Button from './Button'

export default function ButtonGroup({ props, rest }: any) {
	const { buttons, selected } = rest

	const mergedProps = merge({}, props)

	return (
		<MuiButtonGroup {...mergedProps}>
			{buttons.map(({ props, ...rest }: any) => (
				<Button
					props={merge(
						rest?.name === selected
							? {
									sx: {
										backgroundColor: '#8476ef'
									}
							  }
							: {},
						props
					)}
					rest={rest}
				/>
			))}
		</MuiButtonGroup>
	)
}
